<template>
  <div class="ugc-section">
    <div class="ugc-title" :class="curLang"></div>
    <div class="tab-list">
      <div
        class="tab tab1 btns"
        :class="{ active: activeUgcTab == UgcTab.UgcTypeMyPoring }"
        @click="switchUgcTab(UgcTab.UgcTypeMyPoring)"
      ><span>{{ langData.createType6 }}</span></div>
      <div
        class="tab tab2 btns"
        :class="{ active: activeUgcTab == UgcTab.UgcTypeJobShare }"
        @click="switchUgcTab(UgcTab.UgcTypeJobShare)"
      ><span>{{ langData.createType7 }}</span></div>
      <div
        class="tab tab3 btns"
        :class="{ active: activeUgcTab == UgcTab.UgcTypePhoto }"
        @click="switchUgcTab(UgcTab.UgcTypePhoto)"
      ><span>{{ langData.createType5 }}</span></div>
    </div>
    <div class="banner-section">
      <div class="banner-subtitle" :class="[`banner-subtitle-${activeUgcTab}`, curLang]">
        <span>{{ activeUgcTab === UgcTab.UgcTypeMyPoring ? langData.createType6 : activeUgcTab === UgcTab.UgcTypeJobShare ? langData.createType7 : langData.createType5 }}</span>
      </div>
      <div class="banner-picture" :class="[`banner-picture-${activeUgcTab}`, curLang]"></div>
      <div class="banner-content">
        <span v-for="(char, i) in (activeUgcTab === UgcTab.UgcTypeMyPoring ? langData.ugcTabContent6 : activeUgcTab === UgcTab.UgcTypeJobShare ? langData.ugcTabContent7 : langData.ugcTabContent5).replace(/\|/g, '')" :key="i">{{ char }}</span>
      </div>
      <div class="banner-join btns" @click="goUgcList()">
        <span>{{ langData.ugcJoinBtn }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted, onUnmounted } from "vue";
import { UgcTab } from "../typings";
import LanguageHook from "@/hooks/language";

const { curLang, langData } = LanguageHook();

const title = {
  [UgcTab.UgcTypeMyPoring]: "我的波利",
  [UgcTab.UgcTypeJobShare]: "职业分享",
  [UgcTab.UgcTypePhoto]: "美照分享",
};

const activeNavTab = inject("activeNavTab");
const initClass = inject("initClass");
const goUgcList = inject("goUgcList");

const activeUgcTab = inject("activeUgcTab", ref(UgcTab.UgcTypeMyPoring));

// 页面停留时间追踪
const viewPageStartTime = ref(null);

// 计算浏览时长
const formatDuration = (startTime, endTime) => {
  const duration = Math.floor((endTime - startTime) / 1000); // 转换为秒
  // 格式化为 xxHxxMxxS
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  return `${hours > 0 ? hours + "H" : ""}${
    minutes > 0 ? minutes + "M" : ""
  }${seconds}S`;
};

// 上报页面停留时间
const reportStayTime = () => {
  if (viewPageStartTime.value) {
    window.activityDataLayer.push({
      eventName: "stay_time",
      eventType: "首页",
      eventValue: formatDuration(viewPageStartTime.value, new Date()),
      aid: window.activity_name,
      gameId: window.game_id,
    });
  }
};

const getUgcTypeText = (type) => {
  return title[type];
};

// 切换UGC内容标签
const switchUgcTab = (tab) => {
  activeUgcTab.value = tab;
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: getUgcTypeText(tab),
    eventReason: "首页",
    aid: window.activity_name,
    gameId: window.game_id,
  });
};

// 生命周期
onMounted(() => {
  viewPageStartTime.value = new Date();
});

onUnmounted(() => {
  reportStayTime();
});
</script>
